export interface IdentityCardBaseFormType {
    identityCardNumber: string;
    identityCardValidFrom: Date;
    identityCardValidTo: Date;
    identityCardNationalNumber: string;
    identityCardAuthority: string;
    identityCardNationality: string;
}

export const identityCardBaseDefaultValues: IdentityCardBaseFormType = {
    identityCardNumber: "",
    identityCardValidFrom: null,
    identityCardValidTo: null,
    identityCardNationalNumber: "",
    identityCardAuthority: "",
    identityCardNationality: "",
};
